"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactRouterDom = require("react-router-dom");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _selectors = require("../../redux/selectors");
var _SiteInfoModule = _interopRequireDefault(require("../../styles/components/SiteInfo/SiteInfo.module.css"));
var _images = require("../../images");
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @class SiteInfo
 * @param sitesURL url for connecting to the backend   - require
 * @param className class name for SiteInfo
 * @return {JSX.Element}
 * @constructor
 */

const SiteInfo = _ref => {
  let {
    className = ''
  } = _ref;
  const location = (0, _reactRouter.useLocation)();
  const data = (0, _reactRedux.useSelector)(_selectors.getDataSite);
  const webpSupport = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getWebpSupport);
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const {
    id,
    thingSiteAddress = '',
    thingZIPCode = '',
    thingCity = '',
    country = '',
    hasimages = []
  } = data;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_SiteInfoModule.default.wrap, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "".concat(_SiteInfoModule.default.briefInfo, " flex-row ").concat(!data ? _SiteInfoModule.default.hidden : '')
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/sites"
  }, tV(country)), "/", /*#__PURE__*/_react.default.createElement("span", null, tV(thingZIPCode), " ", tV(thingCity)), "/", /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: location.pathname,
    className: _SiteInfoModule.default.bold
  }, "".concat(tV(country), "_").concat(tV(thingZIPCode), "_").concat(tV(thingSiteAddress)))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "".concat(_SiteInfoModule.default.container, " flex-top-center")
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 6,
    md: 4,
    className: _SiteInfoModule.default.image_wrap
  }, id ? /*#__PURE__*/_react.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    wrapperClassName: _SiteInfoModule.default.lazy_load_image,
    onError: event => {
      // eslint-disable-next-line no-param-reassign
      event.target.src = webpSupport ? _images.defaultBuilding.webp.building_def_webp : _images.defaultBuilding.png.building_def_png;
    },
    effect: "blur",
    src: _paulCorePackage.functions.getSupportedImg({
      webpSupport,
      urls: hasimages === null || hasimages === void 0 ? void 0 : hasimages[0],
      imgSizeKey: _paulCorePackage.constants.imgSizeKeys.preview,
      defaultImg: {
        webp: _images.defaultBuilding.webp.building_def_webp,
        original: _images.defaultBuilding.png.building_def_png
      }
    }),
    width: 251
  }) : /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    className: _SiteInfoModule.default.lazy_load_image,
    variant: "rectangular",
    sx: {
      fontSize: 'inherit',
      width: 380
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 12,
    md: 8
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: "fw-bold ".concat(_SiteInfoModule.default.title)
  }, tV(thingSiteAddress) || /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    sx: {
      fontSize: 'inherit',
      width: 380
    }
  })), /*#__PURE__*/_react.default.createElement("h5", {
    className: "fw-normal"
  }, thingZIPCode || thingCity ? "".concat(tV(thingZIPCode), " ").concat(tV(thingCity)) : /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    sx: {
      fontSize: 'inherit',
      height: 30,
      width: 180
    }
  })))));
};
var _default = SiteInfo;
exports.default = _default;